import { isPro } from '@/utils/index.js';
const host = isPro() ? 'https://huituaccess.map.qq.com' : 'https://prehuituaccess.sparta.html5.qq.com';
const host1 = isPro() ? 'https://huitucollect.map.qq.com' : 'https://prehuituaccess.sparta.html5.qq.com';

// 活动首页展示
export const rewardActivityDetailApi = `${host}/ishare_activity/web_activity/rewardActivityDetail`;
// 预约
export const userBookRewardActivityApi = `${host}/ishare_activity/web_activity/userBookRewardActivity`;
// 查询预约详情接口
export const getRewardActivityBookInfoApi = `${host}/ishare_activity/web_activity/getRewardActivityBookInfo`;
// 红包任务列表
export const rewardListApi = `${host}/ishare_activity/web_activity/rewardList`;
// 查询膨胀卡
export const getUserRewardExpandInfoApi = `${host}/ishare_activity/web_activity/getUserRewardExpandInfo`;
// 使用膨胀卡
export const useRewardExpandCard = `${host}/ishare_activity/web_activity/useRewardExpandCard`;

// 查看试卷内容
export const getExamPaperFun = `${host}/mizar/integration/users/getExamPaper`
// 提交答案
export const submitExamAnswer = `${host}/mizar/integration/users/submitUserAnswer`
// 设置cosUrl
export const requestCosUrl = `${host}/mizar/integration/task/getCosSecret`
// 设置cosUrl
export const requestCosUrlNew = `${host}/mizar/integration/task/getCosTmpKey`
// cos桶--上传新方法
export const getCosCredentialsByScene = `${host}/mizar/integration/getCosCredentialsByScene`
// 请求存储桶sign
export const requestCosSign = `${host}/mizar/integration/task/getHuituSign`
// 情报上报接口
export const infoReport = `${host}/mizar/integration/task/infoReport`
// 情报列表页查询接口
export const InfoReportList = `${host}/mizar/integration/task/infoReportList`
// 情报上报黑名单查询
export const InfoReportPrivilegeJudge = `${host}/mizar/integration/users/infoReportPrivilegeJudge`
// 获取令牌
export const accessToken = `${host}/mizar/integration/oauth2/access_token`
// 判断是否是内部用户
export const isStaff = `${host}/mizar/integration/users/isStaff`

// 获取poi情报配置
export const confList = `${host1}/mizar/integration/task/conf/list`

// 心跳
export const heartbeat = `${host}/mizarlet/integration/users/heartbeat`

// 获取下载sign
export const getCosSignByVersion = `${host}/mizar/integration/task/getCosSignByVersion`

// cos 通过url获取解析后的
export const getReadOnlyPresignedUrl = `${host}/mizar/integration/getReadOnlyPresignedUrl`
// 车信上报-去重
export const reportAllowed = `${host}/mizar/integration/v2/tasks/reportAllowed`
// 语音情报上报
export const aiVoiceInfoReport = `${host}/mizar/integration/v2/task/aiVoiceInfoReport`
// 语音上报历史列表
export const aiVoiceInfoReportList = `${host}/mizar/integration/v2/task/aiVoiceInfoReportList`
